import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingWhyRaven } from "@/components/landing/LandingWhyRaven";
import { LandingFeatures } from "@/components/landing/LandingFeatures";
import { LandingShowcase } from "@/components/landing/LandingShowcase";
import { LandingBenefits } from "@/components/landing/LandingBenefits";
import { LandingFAQ } from "@/components/landing/LandingFAQ";
import { LandingCTA } from "@/components/landing/LandingCTA";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { useEffect } from "react";
import { useTheme } from "next-themes";

export default function Landing() {
  const { setTheme, theme } = useTheme();
  
  useEffect(() => {
    const previousTheme = theme;
    setTheme('dark');
    
    return () => {
      if (previousTheme) setTheme(previousTheme);
    };
  }, []);

  useEffect(() => {
    // Scroll suave para los links internos
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-background dark">
      <LandingNavbar />
      <main>
        <LandingHero />
        <LandingWhyRaven />
        <LandingFeatures />
        <LandingShowcase />
        <LandingBenefits />
        <LandingFAQ />
        <LandingCTA />
      </main>
      <LandingFooter />
    </div>
  );
}
